import SellerDashboard from './SellerDashboard';

export default SellerDashboard;
